/**
 * Redux Store Configuration
 */

import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import authReducer from './slices/authSlice';
import micrositesReducer from './slices/micrositesSlice';
import micrositeReducer from './slices/micrositeSlice';
import storeManagementReducer from './slices/storeManagementSlice';
import blogsReducer from './slices/blogsSlice';
import blogReducer from './slices/blogSlice';
import aiPurchaseAnalyticsReducer from './slices/aiPurchaseAnalyticsSlice';
import cpmVerificationQueueReducer from './slices/cpmVerificationQueueSlice';
import cpmOverviewReducer from './slices/cpmOverviewSlice';
import cpmMasterEditorReducer from './slices/cpmMasterEditorSlice';
import cpmExciseCategoryReducer from './slices/cpmExciseCategorySlice';
import configTemplatesListReducer from './slices/configTemplatesListSlice';
import configTemplateDraftReducer from './slices/configTemplateDraftSlice';

// Configure store
export const store = configureStore({
    reducer: {
        auth: authReducer,
        microsites: micrositesReducer,
        microsite: micrositeReducer,
        storeManagement: storeManagementReducer,
        blogs: blogsReducer,
        blog: blogReducer,
        aiPurchaseAnalytics: aiPurchaseAnalyticsReducer,
        cpmVerificationQueue: cpmVerificationQueueReducer,
        cpmOverview: cpmOverviewReducer,
        cpmMasterEditor: cpmMasterEditorReducer,
        cpmExciseCategory: cpmExciseCategoryReducer,
        configTemplatesList: configTemplatesListReducer,
        configTemplateDraft: configTemplateDraftReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types if needed
                ignoredActions: [],
            },
        }),
    devTools: import.meta.env.DEV, // Enable Redux DevTools in development
});

// Infer types from the store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// ============================================
// Typed Hooks
// ============================================

/**
 * Typed useDispatch hook
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Note: useSelector is already typed in individual slice files as custom hooks

export default store;
